import { render } from "./CategoryTree.vue?vue&type=template&id=5f9f4b20&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"

import "./CategoryTree.vue?vue&type=style&index=0&id=5f9f4b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9f4b20"]])

export default __exports__